var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReadReceipts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0003 2.41699C5.81217 2.41699 2.41699 5.81217 2.41699 10.0003C2.41699 14.1885 5.81217 17.5837 10.0003 17.5837C14.1885 17.5837 17.5837 14.1885 17.5837 10.0003C17.5837 5.81217 14.1885 2.41699 10.0003 2.41699ZM0.916992 10.0003C0.916992 4.98374 4.98374 0.916992 10.0003 0.916992C15.0169 0.916992 19.0837 4.98374 19.0837 10.0003C19.0837 15.0169 15.0169 19.0837 10.0003 19.0837C4.98374 19.0837 0.916992 15.0169 0.916992 10.0003ZM10.0003 8.41699C10.4145 8.41699 10.7503 8.75278 10.7503 9.16699V13.3337C10.7503 13.7479 10.4145 14.0837 10.0003 14.0837C9.58611 14.0837 9.25033 13.7479 9.25033 13.3337V9.16699C9.25033 8.75278 9.58611 8.41699 10.0003 8.41699ZM10.0003 7.50033C10.4606 7.50033 10.8337 7.12723 10.8337 6.66699C10.8337 6.20676 10.4606 5.83366 10.0003 5.83366C9.54009 5.83366 9.16699 6.20676 9.16699 6.66699C9.16699 7.12723 9.54009 7.50033 10.0003 7.50033Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadReceipts);
export default __webpack_public_path__ + "static/media/read-receipts.7bfa149cfaa201455fd18b828924c83c.svg";
export { ForwardRef as ReactComponent };